import { render, staticRenderFns } from "./autoNotification.vue?vue&type=template&id=5c2a9a26"
import script from "./autoNotification.vue?vue&type=script&lang=js"
export * from "./autoNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports